// app/frontend/src/utils/rafThrottle.js
export const rafThrottle = (fn) => {
  let rafId = null;
  return (...args) => {
    if (rafId !== null) {
      cancelAnimationFrame(rafId);
    }
    rafId = requestAnimationFrame(() => {
      fn(...args);
      rafId = null;
    });
  };
};
